import type { Disposable } from '@patsnap/tahiti-core';

export const CurrentTaskService = Symbol('CurrentTaskService');

/**
 * 当前任务
 * @description 用于获取当前任务ID，以及判断是否为当前任务
 */
export interface CurrentTaskService {
    readonly taskId: string;
    readonly taskType: string;
    /**
     * 是否为当前任务
     * @param taskId - 任务ID
     * @returns 是否为当前任务
     */
    isCurrentTask(taskId: string): boolean;
    /**
     * 手动设置任务ID
     * @description 用于在没有 URL taskId 的场景下（如首页）手动提供 taskId
     * @param taskId - 要设置的任务ID
     * @returns Disposable 对象，调用 dispose() 可清除手动设置的任务ID
     */
    setManualTaskId(taskId: string): Disposable;
}

